<template>
  <section class="app-common-scope">
    <nuxt-loading-indicator
      color="var(--theme-on-surface)"
      :throttle="0"
      :duration="5e3"
    />

    <ui-dialog-global-container />
  </section>
</template>

<script lang="ts" setup>
interface Props {
  name?: string
}

const props = defineProps<Props>()

provide(props.name, {
  scope: {},
})

const dialogStore = useDialogStore()
const route = useRoute()

function handleCookieConsent() {
  if (import.meta.server) return
  if (route.path.startsWith('/tv')) return
  const consent = localStorage.getItem('cookie-consent')
  if (consent !== 'accepted') {
    dialogStore.modal?.cookieConsent.open()
  }
}
onMounted(handleCookieConsent)
</script>
